"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderEval = exports.default = void 0;
var _qs = _interopRequireDefault(require("qs"));
var _react = _interopRequireDefault(require("react"));
var _Cookie = _interopRequireDefault(require("../../packages/Cookie"));
var _redux = require("../../packages/redux");
var _useQueryParams = _interopRequireDefault(require("../../packages/useQueryParams"));
var _jsxRuntime = require("react/jsx-runtime");
const useCookiedParam = function (page) {
  const [cookieValue, setCookie] = (0, _Cookie.default)(`personalization_${page}`);
  const [condParams, setCondParams] = (0, _redux.useSimpleReducer)(`personalization__${page}`, {
    initialState: cookieValue,
    persist: true
  });
  const getCookiedParams = function () {
    return condParams;
  };
  const setCookiedParams = function (value) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setCookie(value, opts);
    setCondParams(value);
  };
  return [getCookiedParams, setCookiedParams];
};
const renderEval = function (params, renderCondition) {
  const rawConditions = (renderCondition === null || renderCondition === void 0 ? void 0 : renderCondition.split("&")) || [];
  if (rawConditions.length === 0) {
    return true;
  }
  const splitConditons = rawConditions === null || rawConditions === void 0 ? void 0 : rawConditions.map(function (condition) {
    return condition.trim().split("=");
  });
  const conditions = splitConditons === null || splitConditons === void 0 ? void 0 : splitConditons.reduce(function (arr, condition) {
    const isNotCondition = condition[0].indexOf("!") === 0;
    arr.push({
      key: condition[0].replace("!", ""),
      value: condition[1],
      not: isNotCondition
    });
    return arr;
  }, []);
  const allConditionsChecked = conditions.map(function (_ref) {
    let {
      key,
      value,
      not
    } = _ref;
    let passing;
    if (value) {
      passing = params[key] === value;
    } else {
      passing = typeof params[key] !== "undefined";
    }
    return not ? !passing : passing;
  });
  const allConditionsAreTrue = !allConditionsChecked.some(function (i) {
    return i === false;
  });
  return allConditionsAreTrue;
};
exports.renderEval = renderEval;
const ConditionalParamsModule = function (_ref2) {
  let {
    id,
    renderCondition,
    children,
    mockParams
  } = _ref2;
  const page = window.location.pathname.replaceAll(/\W/g, "") + (id ? id : "");
  const [getCookiedParams, setCookiedParams] = useCookiedParam(page);
  const cookiedParam = getCookiedParams();
  const cookiedParamObj = cookiedParam ? _qs.default.parse(cookiedParam) : undefined;
  const queryParameters = (0, _useQueryParams.default)();
  const queryParams = mockParams || queryParameters;
  const hasQueryParamKeys = Object.keys(queryParams).length > 0;
  let params = {};
  if (!hasQueryParamKeys && cookiedParam) {
    params = cookiedParamObj;
  }
  if (hasQueryParamKeys) {
    params = queryParams;
    setCookiedParams(_qs.default.stringify(queryParams));
  }
  const render = renderEval(params, renderCondition);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: render && children
  });
};
var _default = exports.default = ConditionalParamsModule;